<template>
  <div>
    <table-grid
      v-if="rows && rows.length"
      :dashboard="true"
      content="offers"
      :cols="columns"
      :row-formatter="statusFormatter"
      class="hover-click text-center"
      :mobile-cols="[1, 3]"
      :rows="rows"
      @record-click="$emit('open', $event)"
    />
    <div v-if="totalCount > localLimit" class="flex justify-center mt-4">
      <pagination
        :page-count="Math.ceil(totalCount / localLimit)"
        :current-page="localPage"
        @change-page="handlePageChange"
      />
    </div>
    <table-loader v-if="isLoading" class="mt-5" />
    <div class="text-center mt-4">
      <btn
        class="w-50 secondary"
        @click="
          $router.push({
            name: 'Offers',
          })
        "
      >
        {{ $t(`place-dashboard.all-offers`) }}
      </btn>
    </div>
  </div>
</template>

<script>
import TableGrid from '@/components/Table/TableGrid/TableGrid.vue';
import Pagination from '@/components/Pagination/Pagination.vue';
import TableLoader from '@/views/_components/Table/TableLoader.vue';
import Btn from '@/components/Button/Button';
import { date } from '@/util/formatters';
import { getOfferList } from '@/api/v2/requests/offers';
import { formatEntityNumber, EntityPrefix } from '@/util/entity-number';

export default {
  name: 'OffersTable',
  components: {
    TableGrid,
    Pagination,
    TableLoader,
    Btn,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    placeId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      localPage: 1,
      localLimit: 25,
      rows: [],
      totalCount: 0,
      isLoading: false,
    };
  },
  computed: {
    columns() {
      return {
        internalNumber: {
          label: '#',
          colClass: ['w-24'],
          formatter: (value) => formatEntityNumber(EntityPrefix.OBJECT, value),
        },
        title: {
          label: this.$t('brand-offers.title'),
          colClass: ['w-64'],
        },
        createdAt: {
          label: this.$t('brand-offers.created'),
          formatter: date,
          colClass: ['w-28'],
        },
      };
    },
  },
  watch: {
    localPage() {
      this.fetchOffers();
    },
    id() {
      this.fetchOffers();
    },
    placeId() {
      this.fetchOffers();
    },
  },
  mounted() {
    this.fetchOffers();
  },
  methods: {
    async fetchOffers() {
      this.isLoading = true;
      try {
        const { nodes, totalCount } = await getOfferList({
          brandId: this.id,
          placeId: this.placeId,
          page: this.localPage,
          perPage: this.localLimit,
        });
        this.rows = nodes;
        this.totalCount = totalCount;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching offers:', error);
        this.$toast.error(this.$t('brand-offers.error-fetching'));
      } finally {
        this.isLoading = false;
      }
    },
    statusFormatter(row) {
      if (row?.creator?.internalRole) {
        return { ...row, role: row.creator.internalRole };
      }
      return row;
    },
    handlePageChange(page) {
      this.localPage = page;
    },
  },
};
</script>
